import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const useIsFormsAvailableToMePage = () => {
  const location = useLocation();
  const { pathname } = location;
  return useMemo(() => {
    let value = false;
    if (pathname) {
      value = pathname.toLowerCase().includes('corporate-library/forms/forms-available-to-me');
    }
    return value;
  }, [pathname]);
};
